<template>
    <div class="statistic px-0 pt-3 pb-0">

        <v-card class="pa-2 pb-4"
                flat
                tile>
            <v-row>
                <!-- back button -->
                <v-col cols="12" class="py-0">
                    <div class="mb-2">
                        <back-button/>
                    </div>
                </v-col>

                <v-col cols="12" class="py-0">
                    <!-- company statistics -->
                    <v-row>
                        <!-- heading & filters -->
                        <v-col cols="12" md="4" class="py-0">
                            <div class="px-5 pr-md-0">
                                <heading-section classes="d-flex mb-3">
                                    {{ $vuetify.lang.t('$vuetify.page_statistics_detail.company_statistics_title') }}
                                </heading-section>
                                <v-row dense no-gutters class="flex-nowrap flex-md-wrap align-center">
                                    <v-col md="2" class="flex-shrink-0 py-0 px-2">
                                        <v-icon class="text-shadow--default">mdi-filter-outline</v-icon>
                                    </v-col>

                                    <v-col md="10" class="pr-1 pr-md-0">
                                        <item-filter type="select"
                                                    @input="onChangeFilter('filterStatisticsVehicles', $event)"
                                                    :items="filterVehicle"
                                                    item-text="name"
                                                    item-value="value"
                                                    :value="filterStatisticsVehicles"></item-filter>
                                    </v-col>
                                    <v-col md="10" offset-md="2" class="pl-1 pl-md-0 mt-md-2">
                                        <item-filter type="select"
                                                    @input="onChangeFilter('filterStatisticsBrands', $event)"
                                                    :items="filterBrand"
                                                    item-text="name"
                                                    item-value="value"
                                                    :value="filterStatisticsBrands"></item-filter>
                                    </v-col>
                                </v-row>
                                <v-row dense no-gutters class="flex-nowrap align-center mb-6">
                                    <v-col cols="12">
                                        <item-filter type="chip"
                                                    class="mt-3"
                                                    :item-reset-text="itemsResetTextYears"
                                                    @input="onChangeFilter('filterStatisticsYears', $event)"
                                                    :items="filterYear"
                                                    item-text="name"
                                                    item-value="value"
                                                    :value="filterStatisticsYears"></item-filter>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                        <!-- /heading & filters -->

                        <!-- statistics -->
                        <v-col cols="12" md="8" class="py-0">
                            <div class="px-5">
                                <barchart class="mt-3 mb-5"
                                        :statistics="statistics.deep"
                                        :filterVehicle="filterStatisticsVehicles"
                                        :filterBrand="filterStatisticsBrands"
                                        :filterYear="filterStatisticsYears"></barchart>
                            </div>
                        </v-col>
                        <!-- /statistics -->
                    </v-row>
                    <!-- /company statistics -->

                    <!-- team statistics -->
                    <v-row class="mt-5">
                        <!-- heading & filters -->
                        <v-col cols="12" md="4" class="py-0">
                            <div class="px-5 pr-md-0 statistics-filters" :class="{ 'position-fixed' : isSticky }" v-scroll="onScroll" ref="sticky">
                                <heading-section classes="d-flex mb-3">
                                    {{ $vuetify.lang.t('$vuetify.page_statistics_detail.user_statitstics_title') }}
                                </heading-section>

                                <v-row dense no-gutters class="flex-wrap-nowrap align-center mb-5">
                                    <v-col md="2" class="flex-shrink-0 flex-grow-0 py-0 px-2">
                                        <v-icon class="text-shadow--default">mdi-filter-outline</v-icon>
                                    </v-col>

                                    <v-col md="10">
                                        <item-filter type="select"
                                                    @input="onChangeFilter('filterStatisticUserBrands', $event)"
                                                    :items="filterUserBrand"
                                                    item-text="name"
                                                    item-value="value"
                                                    :value="filterStatisticUserBrands"></item-filter>
                                    </v-col>
                                    <v-col cols="12">
                                        <item-filter type="chip"
                                                    class="mt-3"
                                                    :item-reset-text="itemsResetTextYears"
                                                    @input="onChangeFilter('filterStatisticsUserYears', $event)"
                                                    :items="filterYear"
                                                    item-text="name"
                                                    item-value="value"
                                                    :value="filterStatisticsUserYears"></item-filter>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                        <!-- /heading & filters -->

                        <!-- statistics - charts by user -->
                        <v-col cols="12" md="8" class="py-0">
                            <div class="px-5">
                                <v-expansion-panels
                                        accordion flat tile multiple
                                        v-model="panel">
                                    <v-expansion-panel v-for="(user, idx) in statistics.detailed"
                                                    class="transparent white--text"
                                                    :key="user.username">
                                        <v-expansion-panel-header class="px-0" expand-icon="mdi-menu-down" :class="{ 'expansion-panel-header--first' : idx === 0 }">
                                            <div class="d-flex align-center justify-space-between">
                                                <div class="subtitle-1 font-weight-bold">
                                                    {{ user.username }}
                                                </div>
                                                <div class="font-weight-bold" style="font-size: 1.571rem;">
                                                    {{ calcTotal(user, filterStatisticUserBrands, filterStatisticsUserYears) | number }}
                                                </div>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mx-n5">
                                            <user-barchart class="mt-3 mb-5"
                                                        user
                                                        :statistics="user.years"
                                                        :filterBrand="filterStatisticUserBrands"
                                                        :filterYear="filterStatisticsUserYears"></user-barchart>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </div>
                        </v-col>
                        <!-- /statistics - charts by user -->
                    </v-row>
                    <!-- /team statistics -->
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
    // 3rd
    import {
        mapActions,
        mapState
    } from 'vuex';
    // components
    import BackButton from '../components/BackButton';
    import HeadingSection from '../components/HeadingSection';
    import Barchart from '../components/Barchart';
    import UserBarchart from '../components/UserBarchart';
    import ItemFilter from '../components/ItemFilter';
    // models
    import OwnerStatistic from '../models/OwnerStatistic';

    export default {
        name: 'statistic',
        components: {
            BackButton,
            Barchart,
            HeadingSection,
            UserBarchart,
            ItemFilter,
        },
        computed: {
            ...mapState([
                'filterStatisticsVehicles',
                'filterStatisticsBrands',
                'filterStatisticsYears',
                'filterStatisticUserBrands',
                'filterStatisticsUserYears',
            ]),
            itemsResetTextYears() {
                return this.$vuetify.lang.t('$vuetify.page_statistics_detail.filter.all');
            },
            filterVehicle() {
                return [
                    {
                        name: this.$vuetify.lang.t('$vuetify.page_statistics_detail.modelcategory.all'),
                        value: null,
                    },
                    {
                        name: this.$vuetify.lang.t('$vuetify.page_statistics_detail.modelcategory.cuv'),
                        value: 'cuv',
                    },
                    {
                        name: this.$vuetify.lang.t('$vuetify.page_statistics_detail.modelcategory.ww'),
                        value: 'ww',
                    },
                ];
            },
            filterBrand() {
                return [
                    {
                        name: this.$vuetify.lang.t('$vuetify.page_statistics_detail.brands.all'),
                        value: null,
                    },
                    {
                        name: 'KNAUS',
                        value: 'knaus',
                    },
                    {
                        name: 'TABBERT',
                        value: 'tabbert',
                    },
                    {
                        name: 'WEINSBERG',
                        value: 'weinsberg',
                    },
                ];
            },
            filterUserBrand() {
                return [
                    {
                        name: this.$vuetify.lang.t('$vuetify.page_statistics_detail.brands.all'),
                        value: 'all',
                    },
                    {
                        name: 'KNAUS',
                        value: 'knaus',
                    },
                    {
                        name: 'TABBERT',
                        value: 'tabbert',
                    },
                    {
                        name: 'WEINSBERG',
                        value: 'weinsberg',
                    },
                ];
            },
            statistics() {
                return OwnerStatistic.getStatistics();
            },
            filterYear() {
                const filter = [];
                if (this.statistics && this.statistics.deep && this.statistics.deep[0] && this.statistics.deep[0].years) {
                    this.statistics.deep[0].years.forEach((y, index) => {
                        filter.push({
                            id: index,
                            name: y.name,
                            value: y.name,
                        })
                    });
                }
                return filter;
            },
            years() {
                return OwnerStatistic.getYears();
            },
            selectionInitialPosition() {
                return this.$refs.sticky.getBoundingClientRect().top;
            },
        },
        methods: {
            ...mapActions([
                'setFilter',
            ]),
            calcTotal(user, brandFilter, yearFilter) {
                let cuv = 0;
                let ww = 0;
                user.years.forEach((year, yearIndex) => {
                    if (yearFilter.length > 0 && !yearFilter.includes(yearIndex)) return;


                    year.cuv.brands.forEach((brand) => {
                        if (brandFilter && brand.name.toLowerCase() !== brandFilter) return;

                        cuv = cuv + brand.months.reduce((a, c) => a+c, 0);
                    });
                    year.ww.brands.forEach((brand) => {
                        if (brandFilter && brand.name.toLowerCase() !== brandFilter) return;

                        ww = ww + brand.months.reduce((a, c) => a+c, 0);
                    });
                });
                return cuv + ww;

            },
            onChangeFilter(i, v) {
                this.setFilter({ item: i, value: v });
            },
            onScroll(e) {
                if (window.innerWidth > 959) {
                    const startStickyAt = document.querySelector('.expansion-panel-header--first').getBoundingClientRect().top;
                    const pageHeight = document.querySelector('.statistic').scrollHeight;

                    if (startStickyAt <= 100 && (pageHeight - window.scrollY) >= 250) {
                        this.isSticky = true;
                        this.$refs.sticky.style.top = window.scrollY + 50 + 'px';
                    } else {
                        this.isSticky = false;
                        this.$refs.sticky.style.top = '';
                    }
                } else {
                    this.isSticky = false;
                    this.$refs.sticky.style.top = '';
                }
            },
        },
        data() {
            return {
                panel: [0],
                isSticky: false,
            }
        },
    }
</script>
